// Normalize brand names in display copy only, never URLs or identifiers.
export function brandText(value) {
  return typeof value === "string"
    ? value.replace(/\bnomii?\b/gi, "nomii")
    : value;
}
